import React from 'react'
import { useNavigation } from '@react-navigation/core'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { IconArrowBack } from '../../assets/icons'

export default ({ onBackPress }) => {
  const navigation = useNavigation()
  return (
    <TouchableOpacity
      style={styles.button}
      onPress={() => {
        if (onBackPress) {
          onBackPress()
          return
        }
        navigation.goBack()
      }}
    >
      <IconArrowBack width={13.33} height={11.67} />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  button: {
    width: 40,
    height: 40,
    borderRadius: 4,
    backgroundColor: '#F5F7F8',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 10,
    left: 20,
  },
})
